import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { TargetCrudService } from 'src/app/shared/services/target-crud.service';
import { Target } from 'src/app/shared/interfaces/target';



@Component({
  selector: 'app-targets',
  templateUrl: './targets.component.html',
  styleUrls: ['./targets.component.scss']
})
export class TargetsComponent implements OnInit {

  
  targets: Target[];
  target: Target;
  selectedTargets: Target[] = [];

  targetDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private targetService : TargetCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Targets'}
    ];

    this.targets = [];
    this.target = { } as Target ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.targetService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.targets = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Target = jsonItem as Target;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.targets.push(l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.targetService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.targets);
            doc.save('targets.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.targets);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "targets");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedTargets);
      // console.log('SAVEC CSV LOCATIONS ', this.targets);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedTargets, 'targets', exportCols);
   // this.exportService.exportToCsv(this.targets, 'targets', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.target = {} as Target;
    this.submitted = false;
    this.targetDialog = true;
  }

  deleteSelectedTargets() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected targets?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.targets = this.targets.filter(val => !this.selectedTargets.includes(val));
            
            this.selectedTargets.forEach( target => this.targetService.delete(target.$key));
            this.selectedTargets = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Targetss Deleted', life: 3000});
        }
    });
  }

  editTarget(target: Target) {
    this.target = {...target};
    this.targetDialog = true;
  }

  deleteTarget(target: Target) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + target.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.targets = this.targets.filter(val => val.$key !== target.$key);
            this.target = {} as Target;
            this.targetService.delete(target.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Target Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.targetDialog = false;
    this.submitted = false;
  }

  saveTarget() {
    this.submitted = true;

    if ( this.target.name.trim() ) {
      this.target.isEnabled = true;
      
      if (this.target.$key) {
          this.targets[this.findIndexById(this.target.$key)] = this.target;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Target Updated', life: 3000});
          this.targetService.update(this.target);
        } else {
          this.target.position = this.targets.length;
          this.targetService.add(this.target);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Target Created', life: 3000});
      this.targets = [...this.targets];
    }

    this.targetDialog = false;
    this.target = { } as Target;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.targets.length; i++) {
        if (this.targets[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeTarget(target : Target) {
    //console.log("SAVE", target);
    this.targetService.update(target);
  }

  completePosition(target : Target) {
   // console.log("SAVE", target);
  //  this.targetService.updateTarget(target);


    if ( this.newPosition > -1 ) {
        target.position = this.newPosition;
        target = this.checkPositionLimits(target);
        this.reorderElements(target);
        //this.updateDB(target);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.targets);
    // const myClonedArray = [];
    // this.targets.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.targets.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.targets.length - 1 - event.dropIndex;
    const targetToMove = this.targets[startIndex];
    
    
    // console.log('StartIndex', startIndex);
    // console.log('EndIndex', endIndex);

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.targets[index] = this.targets[index+1];
        this.targets[index].position = index;
        this.targetService.update(this.targets[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.targets[index] = this.targets[index-1];
        this.targets[index].position = index;
        this.targetService.update(this.targets[index]);
      }
    } 
    this.targets[endIndex] = targetToMove;
    this.targets[endIndex].position = endIndex;
    this.targetService.update(this.targets[endIndex]);
  }

  // onFieldEdit(target: Spray, fieldName: string): void {
  //   //console.log(this.targets);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + target[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       target.position = this.newPosition;
  //       target = this.checkPositionLimits(target);
  //       this.reorderElements(target);
  //       //this.updateDB(target);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(target);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.targets.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, target: Target) {
    // console.log("event" +event);
    if (target.position != null && target.position > -1) {
      this.previousPosition = target.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(target: Target) {
    console.log('check ',target.position + ' ' + this.targets.length);
    if (!target.position) {
     // console.log('check 1');
      return this.target;
    }
    if (target.position < 0) {
      target.position = 0;
      // console.log('check 2');
      return target;
    }
    if (target.position > this.targets.length) {
      target.position = this.targets.length - 1;
    //  console.log('check 3', target.position);
      return target;
    }
   // console.log('check 4');
    return target;
  }

  async reorderElements(target: Target) {
    this.newPosition = this.newPosition  > this.targets.length ? this.targets.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === target.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const targetToMove = this.targets[startIndex];
   // console.log('Item to move: ', this.targets[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.targets);
        console.log('Item to +1: ', this.targets[index+1]);

        this.targets[index] = this.targets[index+1];
        this.targets[index].position = index;
        // console.log('Move: ', this.targets[index+1]);
        // console.log('Move pos: ', this.targets[index].position);
        //await this.updateDB(this.targets[index]);
        this.targetService.update(this.targets[index]);
     //   console.log('Update DB: ', this.targets[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.targets[index] = this.targets[index-1];
        this.targets[index].position = index;
        this.targetService.update(this.targets[index]);
      }
    } 
    this.targets[endIndex] = targetToMove;
    this.targets[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.targetService.update(this.targets[endIndex]);
    
    // const myClonedArray = [];
    // this.targets.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.targets = myClonedArray;
   // this.getAllRecords();
  }
}
